import { Resource as e } from "@coveo/platform-client";
//#region src/resources/PreviewResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/search/v3/analysis/preview";
	}
	pipelinePreview(e, n) {
		return this.api.post(this.buildPath(`${t.baseUrl}/pipelines/${e}`, { organizationId: this.api.organizationId }), n);
	}
};
//#endregion
export { t as PreviewResource };

//# sourceMappingURL=PreviewResource.js.map